// Mock data for Syasyah Perodua website
export const advisorInfo = {
  name: "Syasyah Aran",
  title: "Your Trusted Perodua Advisor",
  tagline: "Senang Lulus, Senang Dapat Kereta!",
  phone: "012-500 6170",
  location: "Perodua Lon G Setia Auto 3S Kayu Ara, Damansara",
  whatsappLink: "https://wa.me/60125006170",
  tiktokLink: "https://www.tiktok.com/@syasyaharan"
};

// Loan calculation function
export const calculateLoan = (otrPrice, deposit = 0, years = 9, interestRate = 2.90) => {
  const loanAmount = otrPrice - deposit;
  const interestTotal = loanAmount * (interestRate / 100) * years;
  const totalPayment = loanAmount + interestTotal;
  const monthly = Math.round(totalPayment / (years * 12));
  return {
    loanAmount,
    interestTotal,
    totalPayment,
    monthly
  };
};

export const carModels = [
  {
    id: "axia",
    name: "Perodua Axia 2026",
    category: "Hatchback",
    image: "https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/axia.webp",
    interestRate: 2.80,
    interestRateRange: "2.8-3.6%",
    rebate: { amount: 1000, label: "RM1,000" },
    waitingList: "ETA 2–3 bulan ⏳",
    brochureLink: "https://www.perodua.com.my/files/Axia_Brochure.pdf?v=1749797573",
    variants: [
      { name: "1.0 G", price: 40310, fullLoan9: 467, deposit10_9: 421 },
      { name: "1.0 X", price: 41770, fullLoan9: 484, deposit10_9: 436 },
      { name: "1.0 SE", price: 45880, fullLoan9: 532, deposit10_9: 479 },
      { name: "1.0 AV", price: 51520, fullLoan9: 597, deposit10_9: 538 }
    ],
    description: "Compact, fuel-efficient, and perfect for city driving",
    specs: {
      engine: "1KR-VE, DOHC, 12V EFI with VVT-i",
      displacement: "998 cc",
      power: "50 kW / 6,000 rpm",
      torque: "91 Nm / 4,400 rpm",
      transmission: "D-CVT",
      fuelConsumption: "27.4 km/l (AV) / 25.3 km/l",
      dimensions: "3,760 x 1,665 x 1,505 mm",
      luggage: "265 L",
      safety: "6 Airbags (AV), A.S.A. 2.0, VSC, ABS with EBD",
      ncap: "5-Star ASEAN NCAP (AV)"
    }
  },
  {
    id: "bezza",
    name: "Perodua Bezza 2026",
    category: "Sedan",
    image: "https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/bezza.webp",
    interestRate: 2.80,
    interestRateRange: "2.8-3.6%",
    rebate: null,
    waitingList: "ETA 1–3 bulan ⏳",
    brochureLink: "https://www.perodua.com.my/files/Bezza_Brochure.pdf?v=1724919068",
    variants: [
      { name: "1.0 G (MT)", price: 36180, fullLoan9: 419, deposit10_9: 377 },
      { name: "1.0 G (AT)", price: 38240, fullLoan9: 443, deposit10_9: 399 },
      { name: "1.3 X (AT)", price: 45860, fullLoan9: 532, deposit10_9: 478 },
      { name: "1.3 AV (AT)", price: 52030, fullLoan9: 603, deposit10_9: 543 }
    ],
    description: "Spacious sedan with excellent fuel economy",
    specs: {
      engine: "1.0L: 1KR-VE DOHC VVT-i / 1.3L: 1NR-VE DOHC Dual VVT-i",
      displacement: "998 cc / 1,329 cc",
      power: "50 kW (1.0L) / 70 kW (1.3L) @ 6,000 rpm",
      torque: "91 Nm (1.0L) / 121 Nm (1.3L)",
      transmission: "5-MT / 4-E-AT",
      fuelConsumption: "22.8 km/l (1.0L) / 22.0 km/l (1.3L)",
      dimensions: "4,170 x 1,620 x 1,525 mm",
      luggage: "508 L",
      safety: "Dual Airbags, A.S.A. 2.0 (AV), VSC, ABS with EBD",
      ncap: "5-Star ASEAN NCAP (AV) / 4-Star (X, G)"
    }
  },
  {
    id: "myvi",
    name: "Perodua Myvi 2026",
    category: "Hatchback",
    image: "https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/myvi.webp",
    interestRate: 2.80,
    interestRateRange: "2.8-3.6%",
    rebate: { amount: 1000, label: "RM1,000" },
    waitingList: "ETA 1–3 bulan ⏳",
    brochureLink: "https://www.perodua.com.my/files/Myvi_Brochure.pdf?v=1758163069",
    variants: [
      { name: "1.3 G", price: 50490, fullLoan9: 585, deposit10_9: 527 },
      { name: "1.5 X", price: 53010, fullLoan9: 615, deposit10_9: 553 },
      { name: "1.5 H", price: 57120, fullLoan9: 662, deposit10_9: 596 },
      { name: "1.5 AV", price: 62260, fullLoan9: 722, deposit10_9: 650 }
    ],
    description: "Malaysia's favourite hatchback with proven reliability",
    specs: {
      engine: "1.3L: 1NR-VE / 1.5L: 2NR-VE DOHC Dual VVT-i",
      displacement: "1,329 cc / 1,496 cc",
      power: "70 kW (1.3L) / 76 kW (1.5L) @ 6,000 rpm",
      torque: "121 Nm (1.3L) / 137 Nm (1.5L)",
      transmission: "D-CVT",
      fuelConsumption: "22.2 km/l (1.3L) / 21.1 km/l (1.5L)",
      dimensions: "3,895 x 1,735 x 1,515 mm",
      luggage: "277 L (1.3G) / 303 L (1.5L)",
      safety: "4-6 Airbags, PSDA, A.S.A., VSC, ABS with EBD",
      ncap: "5-Star ASEAN NCAP"
    }
  },
  {
    id: "ativa",
    name: "Perodua Ativa 2026",
    category: "SUV",
    image: "https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/ativa.webp",
    interestRate: 2.30,
    interestRateRange: "2.3-2.8%",
    rebate: { amount: 2000, label: "RM2,000" },
    waitingList: "Fast Stock 🚗 ETA 2–4 minggu",
    brochureLink: "https://www.perodua.com.my/files/Ativa_Brochure.pdf?v=1764216623",
    variants: [
      { name: "1.0 X", price: 64880, fullLoan9: 725, deposit10_9: 653 },
      { name: "1.0 H", price: 69820, fullLoan9: 780, deposit10_9: 702 },
      { name: "1.0 AV", price: 75260, fullLoan9: 841, deposit10_9: 757 },
      { name: "1.0 AV 2-Tone", price: 76090, fullLoan9: 850, deposit10_9: 765 }
    ],
    description: "Compact SUV with turbocharged performance",
    specs: {
      engine: "1KR-VE TURBO",
      displacement: "998 cc",
      power: "72 kW (98 PS) / 6,000 rpm",
      torque: "140 Nm / 2,400-4,000 rpm",
      transmission: "D-CVT",
      fuelConsumption: "18.9 km/l (ECO Idle)",
      dimensions: "4,065 x 1,710 x 1,635 mm",
      groundClearance: "200 mm",
      luggage: "303 L / 369 L",
      safety: "6 Airbags, A.S.A., VSC, ACC, LKC, BSM, ADB",
      ncap: "5-Star ASEAN NCAP"
    }
  },
  {
    id: "traz",
    name: "Perodua Traz 2026",
    category: "SUV",
    image: "/models/traz_nobg.png",
    logo: "/models/traz_logo.png",
    interestRate: 2.30,
    interestRateRange: "2.3-2.8%",
    rebate: null,
    waitingList: "🔥 NEW MODEL - Available Now!",
    brochureLink: "https://www.perodua.com.my/files/Traz_Brochure.pdf?v=1765937418",
    isNew: true,
    variants: [
      { name: "1.5 X (CVT)", price: 78940, fullLoan9: 882, deposit10_9: 794 },
      { name: "1.5 H (CVT)", price: 84080, fullLoan9: 940, deposit10_9: 846 },
      { name: "1.5 H (CVT) 2-Tone", price: 85010, fullLoan9: 950, deposit10_9: 855 }
    ],
    description: "Brand NEW 5-seater SUV - Trendy, Reliable, Adaptive, Zealous",
    specs: {
      engine: "2NR-VE, 4 cylinders, DOHC EFI",
      displacement: "1,496 cc",
      power: "78 kW / 6,000 rpm",
      torque: "138 Nm / 4,200 rpm",
      transmission: "D-CVT (Eco, Normal, Power mode)",
      fuelConsumption: "21.3 km/l (MDC Mode)",
      dimensions: "4,310 x 1,770 x 1,655 mm",
      groundClearance: "210 mm",
      luggage: "471 L",
      safety: "6 Airbags, A.S.A., LDW, LDP, BSM, RCTA, 360° Camera (H)",
      ncap: "5-Star ASEAN NCAP",
      warranty: "5 Years / 150,000 km"
    }
  },
  {
    id: "alza",
    name: "Perodua Alza 2026",
    category: "MPV",
    image: "https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/alza.webp",
    interestRate: 2.30,
    interestRateRange: "2.3-2.8%",
    rebate: null,
    waitingList: "ETA 1–4 bulan ⏳",
    brochureLink: "https://www.perodua.com.my/files/Alza_Brochure.pdf?v=1724919067",
    variants: [
      { name: "1.5 X", price: 68580, fullLoan9: 766, deposit10_9: 690 },
      { name: "1.5 H", price: 73570, fullLoan9: 822, deposit10_9: 740 },
      { name: "1.5 AV", price: 78020, fullLoan9: 872, deposit10_9: 785 }
    ],
    description: "Versatile 7-seater MPV for families on the go",
    specs: {
      engine: "2NR-VE, 4 Cylinders, DOHC EFI Dual VVT-i",
      displacement: "1,496 cc",
      power: "78 kW / 6,000 rpm",
      torque: "138 Nm / 4,200 rpm",
      transmission: "D-CVT (Eco, Normal, Power mode)",
      fuelConsumption: "22.0 km/l (ECO Idle)",
      dimensions: "4,425 x 1,730 x 1,670 mm",
      seating: "7-Seater",
      luggage: "137 L / 498 L (3rd row down)",
      safety: "6 Airbags, PSDA, A.S.A., ACC, LKC, BSM, 360° Camera (AV)",
      ncap: "5-Star ASEAN NCAP"
    }
  },
  {
    id: "aruz",
    name: "Perodua Aruz 2026",
    category: "SUV",
    image: "https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/aruz.webp",
    interestRate: 2.30,
    interestRateRange: "2.3-2.8%",
    rebate: { amount: 3000, label: "RM3,000" },
    waitingList: "Fast Stock 🚗 ETA bawah 1 bulan",
    brochureLink: "https://www.perodua.com.my/files/UpdatedAruz_Brochure.pdf?v=1756463190",
    variants: [
      { name: "1.5 X", price: 72900, fullLoan9: 815, deposit10_9: 733 },
      { name: "1.5 AV", price: 77900, fullLoan9: 871, deposit10_9: 784 }
    ],
    description: "7-seater SUV for adventure and family trips",
    specs: {
      engine: "2NR-VE, 4 Cylinders, DOHC Dual VVT-i",
      displacement: "1,496 cc",
      power: "75 kW / 6,000 rpm",
      torque: "133 Nm / 4,200 rpm",
      transmission: "4 E-AT",
      fuelConsumption: "15.6 km/l (ECO Idle)",
      dimensions: "4,435 x 1,695 x 1,740 mm",
      groundClearance: "220 mm",
      seating: "7-Seater",
      luggage: "213 L / 514 L (3rd row down)",
      safety: "6 Airbags, A.S.A. 2.0 (AV), VSC, HSA, DVR",
      ncap: "5-Star ASEAN NCAP"
    }
  }
];

export const loanDocuments = [
  {
    icon: "FileText",
    title: "Copy IC/Lesen",
    description: "Salinan kad pengenalan dan lesen memandu (depan & belakang)"
  },
  {
    icon: "Receipt",
    title: "Payslip 3 Bulan",
    description: "Slip gaji 3 bulan terkini dari majikan"
  },
  {
    icon: "CreditCard",
    title: "Statement Bank 3 Bulan",
    description: "Penyata bank 3 bulan terkini"
  }
];

export const modelColors = {
  axia: {
    all: [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Lava Red", code: "#DC143C", type: "Metallic" },
      { name: "Coral Blue", code: "#4682B4", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" }
    ]
  },
  bezza: {
    all: [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Sugar Brown", code: "#8B4513", type: "Metallic" },
      { name: "Garnet Red", code: "#B22222", type: "Metallic" },
      { name: "Ocean Blue", code: "#1E90FF", type: "Metallic" }
    ]
  },
  myvi: {
    all: [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Cranberry Red", code: "#DC143C", type: "Metallic" },
      { name: "Electric Blue", code: "#0047AB", type: "Metallic" }
    ]
  },
  ativa: {
    "1.0 X": [
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Cobalt Blue", code: "#0047AB", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" }
    ],
    "1.0 H": [
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Cobalt Blue", code: "#0047AB", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Pearl Diamond White", code: "#F0F8FF", type: "Special Metallic", isPearl: true },
      { name: "Pearl Delima Red", code: "#DC143C", type: "Special Metallic", isPearl: true }
    ],
    "1.0 AV": [
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Pearl Diamond White", code: "#F0F8FF", type: "Special Metallic", isPearl: true },
      { name: "Pearl Delima Red", code: "#DC143C", type: "Special Metallic", isPearl: true }
    ],
    "1.0 AV 2-Tone": [
      { name: "2-Tone Pearl Diamond White", code: "#F0F8FF", type: "2-Tone Special", isTwoTone: true },
      { name: "2-Tone Pearl Delima Red", code: "#DC143C", type: "2-Tone Special", isTwoTone: true }
    ]
  },
  traz: {
    "1.5 X (CVT)": [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Cranberry Red", code: "#DC143C", type: "Metallic" }
    ],
    "1.5 H (CVT)": [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Cranberry Red", code: "#DC143C", type: "Metallic" },
      { name: "Electric Blue", code: "#0066CC", type: "2-Tone Metallic", isTwoTone: true },
      { name: "Glittering Silver 2-Tone", code: "#C0C0C0", type: "2-Tone Metallic", isTwoTone: true }
    ],
    "1.5 H (CVT) 2-Tone": [
      { name: "Electric Blue 2-Tone", code: "#0066CC", type: "2-Tone Metallic", isTwoTone: true },
      { name: "Glittering Silver 2-Tone", code: "#C0C0C0", type: "2-Tone Metallic", isTwoTone: true }
    ]
  },
  alza: {
    "1.5 X": [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Elegant Black", code: "#2F2F2F", type: "Metallic" }
    ],
    "1.5 H": [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Elegant Black", code: "#2F2F2F", type: "Metallic" },
      { name: "Garnet Red", code: "#B22222", type: "Metallic" },
      { name: "Vintage Brown", code: "#8B4513", type: "Metallic" }
    ],
    "1.5 AV": [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Elegant Black", code: "#2F2F2F", type: "Metallic" },
      { name: "Garnet Red", code: "#B22222", type: "Metallic" },
      { name: "Vintage Brown", code: "#8B4513", type: "Metallic" }
    ]
  },
  aruz: {
    "1.5 X": [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Elegant Black", code: "#2F2F2F", type: "Metallic" }
    ],
    "1.5 AV": [
      { name: "Ivory White", code: "#F8F8FF", type: "Solid" },
      { name: "Glittering Silver", code: "#C0C0C0", type: "Metallic" },
      { name: "Granite Grey", code: "#696969", type: "Metallic" },
      { name: "Garnet Red", code: "#B22222", type: "Metallic" },
      { name: "Elegant Black", code: "#2F2F2F", type: "Metallic" },
      { name: "Vintage Brown", code: "#8B4513", type: "Metallic" }
    ]
  }
};

export const colorOptions = [
  { category: "Solid", colors: ["Ivory White", "Glittering Silver", "Lava Red", "Granite Grey"] },
  { category: "Metallic", colors: ["Cobalt Blue", "Electric Blue", "Passion Red", "Glitter Black"] },
  { category: "Premium (AV model)", colors: ["Pearl Diamond White", "Pearl Delima Red", "Pearl Electric Blue"] }
];

export const benefits = [
  {
    icon: "CreditCard",
    title: "Uruskan Loan",
    description: "Student / PTPTN pun boleh apply"
  },
  {
    icon: "TrendingUp",
    title: "Fast Approval",
    description: "Hubungan rapat dengan banker"
  },
  {
    icon: "Percent",
    title: "Interest Paling Rendah",
    description: "Dapatkan kadar faedah terbaik"
  },
  {
    icon: "Gift",
    title: "Exclusive Gift",
    description: "Tinted, minyak full, hadiah misteri"
  },
  {
    icon: "Users",
    title: "Tiada Lesen?",
    description: "Boleh guna lesen keluarga"
  }
];

export const testimonials = [
  {
    name: "Ahmad Rahman",
    model: "Perodua Myvi 2026",
    comment: "Terima kasih Syasyah! Proses loan sangat cepat dan mudah. Dapat kereta impian dalam masa seminggu je!",
    rating: 5
  },
  {
    name: "Siti Nurhaliza",
    model: "Perodua Axia 2026",
    comment: "Syasyah sangat membantu. Walaupun saya student, dia uruskan everything sampai dapat kereta. Highly recommended!",
    rating: 5
  },
  {
    name: "Raj Kumar",
    model: "Perodua Ativa 2026",
    comment: "Best advisor ever! Patient explain semua details, interest rate pun dapat yang paling murah. Worth it!",
    rating: 5
  }
];